export const ADD_SAMPLE = 'ADD_SAMPLE';
export const REMOVE_SAMPLE = 'REMOVE_SAMPLE';
export const CLEAR_SAMPLES = 'CLEAR_SAMPLES';
export const UPDATE_SAMPLE_CART = 'UPDATE_SAMPLE_CART';
export const REMOVE_POST = 'REMOVE_POST';
